import { warehouseBankApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const WAREHOUSE_BANK_ACTION_TYPE = createNamedActions('warehouseBank', {
  GET_WAREHOUSE_BANKS: 'GET_WAREHOUSE_BANKS',
  GET_WAREHOUSE_BANK_LIST: 'GET_WAREHOUSE_BANK_LIST',
  CREATE_WAREHOUSE_BANK: 'CREATE_WAREHOUSE_BANK',
  EDIT_WAREHOUSE_BANK: 'EDIT_WAREHOUSE_BANK',
  DELETE_WAREHOUSE_BANK: 'DELETE_WAREHOUSE_BANK',
});

const warehouseBankSchema = new schema.Entity('data', {}, { idAttribute: 'warehouseBankId' });

export const getWarehouseBanksAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseBankApi.getWarehouseBanks(params);

  return dispatch({
    type: WAREHOUSE_BANK_ACTION_TYPE.GET_WAREHOUSE_BANKS,
    payload: normalize(data, [warehouseBankSchema]).entities.data,
  });
});

export const getWarehouseBankListAction = catchAsyncActionError(
  ({ entityType }) =>
    async dispatch => {
      const { data } = await warehouseBankApi.getWarehouseBankList({ entityType });

      return dispatch({
        type: WAREHOUSE_BANK_ACTION_TYPE.GET_WAREHOUSE_BANK_LIST,
        payload: data.map(warehouse => ({ ...warehouse, isAvailable: true })),
      });
    },
);

export const createWarehouseBankAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseBankApi.createWarehouseBank(params);

  return dispatch({
    type: WAREHOUSE_BANK_ACTION_TYPE.CREATE_WAREHOUSE_BANK,
    payload: data,
  });
});

export const editWarehouseBankAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseBankApi.editWarehouseBank(params);

  return dispatch({
    type: WAREHOUSE_BANK_ACTION_TYPE.EDIT_WAREHOUSE_BANK,
    payload: data,
  });
});

export const deleteWarehouseBankAction = catchAsyncActionError(params => async dispatch => {
  await warehouseBankApi.deleteWarehouseBank(params);

  return dispatch({
    type: WAREHOUSE_BANK_ACTION_TYPE.DELETE_WAREHOUSE_BANK,
    meta: params,
  });
});
